import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Button, Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { RegisterMyTaskReport } from "../../services/employeeApi.js";
import { toast } from "react-toastify";
import { validateForm } from "../../middleware/validatemyTaskReportForm.js";
const RegisterTaskReportForm = ({ reportData, onSubmitButton }) => {
  const { t } = useTranslation();
  let history = useHistory();
  const [formerror, setFormError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const queryClient = useQueryClient();
  const registrationMutation = useMutation(async (newData) => {
    await RegisterMyTaskReport(newData);
    queryClient.invalidateQueries("get-my-tasks-status");
  });

  const [formData, setFormData] = useState({
    employee_id: reportData.employee_id,
    task_id: reportData.task_id,
    branch_id: reportData.branch_id,
    current_remark: "",
    quantity: 0,
    date: new Date().toISOString().split("T")[0],
    created_by: "",
    updated_by: "",
  });

  const handleRegistration = async (ReportData) => {
    try {
      setIsSubmitting(true);
      await registrationMutation.mutateAsync(ReportData);
      toast.success("Registration successful", {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      handleCloseModal();
      history.push(`/my-tasks`);
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const requiredFields = ["date", "quantity"];
    const isEmptyField = requiredFields.some((field) => !formData[field]);
    if (isEmptyField) {
      setFormError(true);
      return;
    }
    const errors = validateForm(formData);
    if (Object.keys(errors).length === 0) {
      handleRegistration(formData);
    } else {
      setValidationErrors(errors);
    }
  };

  const handleCloseModal = () => {
    onSubmitButton();
  };

  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="col-md-12 mb-3">
          <Form.Label className="font-weight-bold text-muted">
            {t("task_name")} {reportData.task_name}
          </Form.Label>
        </div>

        <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text4" className="font-weight-bold text-muted ">
            {t("date")}
          </Form.Label>
          <Form.Control
            type="date"
            required
            placeholder="Enter date"
            value={formData.date}
            max={new Date().toISOString().split("T")[0]}
            onChange={(e) => handleInputChange(e, "date")}
          />
        </div>
        {/* <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text4" className="font-weight-bold text-muted ">
            {t("to_date")}
          </Form.Label>
          <Form.Control
            type="date"
            placeholder="Enter end date"
            required
            value={formData.end_date}
            onChange={(e) => handleInputChange(e, "end_date")}
          />

          {validationErrors.end_date && (
            <div className="text-danger">{validationErrors.end_date}</div>
          )}
        </div> */}
        <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text1" className="font-weight-bold text-muted ">
            {t("quantity")}
          </Form.Label>
          <Form.Control
            type="number"
            min="0"
            required
            placeholder="Enter Quantity"
            value={formData.quantity}
            rows={3}
            onChange={(e) => handleInputChange(e, "quantity")}
          />
        </div>
        <div className="col-md-12 mb-3">
          <Form.Label htmlFor="Text1" className="font-weight-bold text-muted ">
            {t("remark")}
          </Form.Label>
          <Form.Control
            as="textarea"
            id="horizontalTextarea"
            rows="3"
            value={formData.current_remark}
            onChange={(e) => handleInputChange(e, "current_remark")}
            placeholder="Provide details for managerial consideration"
          ></Form.Control>
          {formerror ? (
            <p className="text-danger">
              Looks like something’s missing! Please make sure to complete all
              required fields before submitting your report.
            </p>
          ) : (
            ""
          )}
        </div>

        <div className="d-flex mt-1">
          <div className="mb-1">
            <Button className="bt btn-secondary" onClick={handleCloseModal}>
              {t("cancel")}
            </Button>
          </div>
          <div className="col-md-6 mb-1">
            <Button
              className="bt btn-info"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span>
                  <Spinner
                    as="span"
                    animation="grow"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="visually-hidden">Sending...</span>
                </span>
              ) : (
                t("register")
              )}
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
};

export default RegisterTaskReportForm;
